(function(){
  // Supports multiple instances of this section on one page: each ".hs-bar" wrapper
  // owns its own carousel, progress bar and dots, scoped independently.
  document.querySelectorAll('.hero .hs-bar').forEach(function(bar){
    var c = bar.querySelector('.hs-carousel');
    if(!c) return;
    var slides = [].slice.call(c.querySelectorAll('.hsq'));
    var dots = [].slice.call(bar.querySelectorAll('.hs-dot'));
    var prog = bar.querySelector('.hs-prog i');
    var PERIOD = 8000, TICK = 60, idx = 0, el = 0, paused = false;

    function mark(i){ dots.forEach(function(d,n){ d.classList.toggle('is-on', n===i); }); }
    function reset(){ el = 0; if(prog) prog.style.width = '0%'; }
    function go(i){
      idx = ((i % slides.length) + slides.length) % slides.length;
      var x = idx * c.clientWidth;
      if(c.scrollTo){ c.scrollTo({left:x, behavior:'smooth'}); } else { c.scrollLeft = x; }
      setTimeout(function(){ if(Math.abs(c.scrollLeft - x) > 2){ c.scrollLeft = x; } }, 450);
      mark(idx);
    }
    setInterval(function(){
      if(paused) return;
      el += TICK;
      var p = Math.min(1, el / PERIOD);
      if(prog) prog.style.width = (p*100).toFixed(1) + '%';
      if(p >= 1){ reset(); go(idx+1); }
    }, TICK);
    c.addEventListener('scroll', function(){
      var i = Math.round(c.scrollLeft / c.clientWidth);
      if(i !== idx){ idx = i; mark(i); reset(); }
    }, {passive:true});
    dots.forEach(function(d,n){ d.addEventListener('click', function(){ reset(); go(n); }); });
    c.addEventListener('pointerdown', function(){ paused = true; });
    c.addEventListener('pointerup', function(){ paused = false; reset(); });
    c.addEventListener('mouseenter', function(){ paused = true; });
    c.addEventListener('mouseleave', function(){ paused = false; });
    window.addEventListener('resize', function(){ c.scrollLeft = idx * c.clientWidth; });
  });
})();
